import { VersionSectionConfig } from "../models/VersionSectionConfig";

export const AppClientConfig: VersionSectionConfig = {
    packageName: 'com.edtsoft.t_llevoclient'
}